import React, { useEffect, useState } from 'react'
import Loader from '../../components/loader/Loader'
import { ServiceModel } from '../../types/services/serviceModel'
import ServicesPageHeader from './components/ServicesPageHeader'
import { ClassValue } from 'classnames/types'
import classNames from 'classnames'
import { useMediaQuery } from 'react-responsive'
import makeStyles from '@material-ui/core/styles/makeStyles'
import styles from '../../styles'
import { FormattedMessage, useIntl } from 'react-intl'
import fetchFactory from '../../utils/fetchFactory'
import { saveServices } from '../reducers/services/actions'
import errorCatcher from '../../utils/errorCatcher'
import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../reducers'
import ServiceItem from './components/ServiceItem'

const useStyle = makeStyles((theme) => {
	return {
		...styles(theme)
	}
})

const ID_SERVICES = 'services'

const ServicesPage: React.FC = () => {
	const dispatch = useDispatch()
	const intl = useIntl()
	const [loading, setLoading] = useState<Boolean>(false)
	const services: ServiceModel = useSelector((state: RootState) => state.services)

	useEffect(
		() => {
			if (services.content.length === 0 || (services.locale && services.locale !== intl.locale)) {
				setLoading(true)

				fetchFactory(`/api/ec_${process.env.REACT_APP_TARGET}/information/getServices?language=${intl.locale}`)
					.then(
						(response: any) => {
							dispatch(
								saveServices({ ...response, locale: intl.locale })
							)
						}
					)
					.catch(
						(error: any) => {
							dispatch(
								errorCatcher(error, ID_SERVICES)
							)
						}
					)
					.finally(
						() => {
							setLoading(false)
						}
					)
			}
		}, [dispatch, intl.locale, services.content.length, services.locale]
	)

	const classes = useStyle()
	const isLargeScreen = useMediaQuery(
		{
			query: '(min-width: 1025px)'
		}
	)

	const subTitleClass: ClassValue = classNames(
		classes.colorBlue,
		isLargeScreen ? classes.title8 : classes.title7
	)

	if (loading) {
		return <Loader />
	}
	return <>
		{services.header.title && <ServicesPageHeader header={services.header} />}
		{services.content.length > 0 ? <div className="row">
				{services.content.map((service) => <div className="col-xs-12 col-md-6" key={service.id}>
					<ServiceItem service={service} />
				</div>)}
			</div>
			:
			<div>
                <span className={subTitleClass}><FormattedMessage
	                id="services.emptyState"
	                defaultMessage="Des services seront bientôt disponibles dans votre résidence, stay tuned !"
	                description="Services list empty message"
                /></span>
			</div>
		}
	</>
}

export default ServicesPage
